import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CalculateModule } from '@libs/shared/components/calculate/calculate.module';
import { ButtonModule } from '@libs/shared/components/button/button.module';
import { NgOptimizedImage } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-accession',
  templateUrl: './accession.component.html',
  styleUrls: ['./accession.component.sass'],
  standalone: true,
  imports: [TranslateModule, CalculateModule, ButtonModule, NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessionComponent {
  private router = inject(Router);

  public navigateLogin() {
    this.router.navigateByUrl('/auth/login').then();
  }
}
